import React from "react";

function Footer() {
  return (
    <footer className="Footer">
      <p>
        Copyright © 2024 - Designed and maintained by{" "}
        <a href="https://github.com/pablogiroud" target="_blank" rel="noopener noreferrer">PG</a>
      </p>
    </footer>
  );
}

export default Footer;
